import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { ArrowRightIcon, Button as Button$1 } from '@elseu/sdu-titan';
import { Link } from '../Link/Link.js';

/**
 * The Button component
 *
 * @param {ButtonProps} props - The props for the Button component.
 * @returns {JSX.Element} The Button component.
 */
var Button = function (_a) {
  var label = _a.label,
    href = _a.href,
    variant = _a.variant,
    isExternalProp = _a.isExternal,
    props = __rest(_a, ["label", "href", "variant", "isExternal"]);
  /** If the href starts with /api/ it is an external link for PDF's */
  var isExternal = isExternalProp || href.startsWith('/api/');
  return variant === 'link' ? jsx(Link, {
    to: href,
    isExternal: isExternal,
    suffixAdornment: jsx(ArrowRightIcon, {}),
    children: label
  }) : jsx(Button$1, __assign({
    href: href,
    variant: variant === 'tertiary' ? 'clear' : variant,
    target: isExternal ? '_blank' : undefined,
    rel: isExternal ? 'noopener noreferrer' : undefined,
    size: "L",
    iconRight: jsx(ArrowRightIcon, {})
  }, props, {
    children: label
  }));
};

export { Button };
//# sourceMappingURL=Button.js.map
